import * as React from "react"
import { Logo } from "./logo-overlay.styled"
import { LogoOverlayProps } from "./logo-overlay.interface"

const _LogoOverlay: React.FC<LogoOverlayProps> = ({ isMobile, src }) => {
  return <Logo data={src} isMobile={isMobile} aria-label=" " />
}
export const LogoOverlay = React.memo(_LogoOverlay)
